/**
 * SybaSoil IG test STARTED-state gate (shared).
 * IG pre-assigns Variant-B in the ig-vars cookie even while the test is
 * PENDING. The IG SDK (window.igData.user.getVariation(UUID)) returns the
 * variation id ONLY when the test is actually STARTED. Gate offer/bridge
 * behaviour on this so PENDING shows pure Control everywhere.
 * NOTE: once STARTED, the SDK returns a variation OBJECT (id full UUID +
 * isControl) — resolveVariation normalises this to the short trailing-12
 * constants so downstream === comparisons are unaffected.
 */
(function () {
  'use strict';
  var SYBA_UUID = '7d2a2169-f16c-4d62-b8aa-802bcaac8d6c';
  var VARIANT_B = '262f9d384523';
  var CONTROL   = 'f670b1f1b8d7';

  function resolveVariation() {
    try {
      var u = window.igData && window.igData.user;
      if (!u || typeof u.getVariation !== 'function') return undefined; // SDK not ready
      var v = u.getVariation(SYBA_UUID);
      if (v == null) return null; // pending OR unassigned
      // Started test: SDK returns an object for THIS test's variation, e.g.
      // {id:"c4fa0b79-…-262f9d384523", isControl:false}. Normalise to the
      // short constant so downstream === comparisons keep working.
      if (typeof v === 'object') {
        if (v.isControl === true) return CONTROL;
        if (v.isControl === false) return VARIANT_B;
        var oid = String(v.id || v.variationId || v.variation || '');
        if (oid === VARIANT_B || oid.slice(-12) === VARIANT_B) return VARIANT_B;
        if (oid === CONTROL  || oid.slice(-12) === CONTROL)  return CONTROL;
        return null;
      }
      // Legacy/cookie string form ('262f9d384523' or a full UUID string).
      var s = String(v);
      if (s === VARIANT_B || s.slice(-12) === VARIANT_B) return VARIANT_B;
      if (s === CONTROL  || s.slice(-12) === CONTROL)  return CONTROL;
      return null;
    } catch (e) {
      return undefined;
    }
  }

  // Synchronous: true ONLY if STARTED + assigned Variant-B. false otherwise
  // (pending, control, SDK-not-ready, error) — safe default = Control UX.
  function checkVariantBSync() {
    return resolveVariation() === VARIANT_B;
  }
  function checkControlSync() {
    return resolveVariation() === CONTROL;
  }
  // Async: waits up to ~5s for the IG SDK, then calls cb(stateString)
  // where state is 'variant-b' | 'control' | 'inactive'.
  function whenResolved(cb) {
    var tries = 0;
    function tick() {
      var v = resolveVariation();
      if (v === undefined && tries < 25) { tries++; setTimeout(tick, 200); return; }
      if (v === VARIANT_B) return cb('variant-b');
      if (v === CONTROL) return cb('control');
      return cb('inactive');
    }
    tick();
  }

  window.SybaIG = {
    SYBA_UUID: SYBA_UUID,
    VARIANT_B: VARIANT_B,
    CONTROL: CONTROL,
    checkVariantBSync: checkVariantBSync,
    checkControlSync: checkControlSync,
    whenResolved: whenResolved
  };
})();
